import { DomainEvent, MessageName } from "@lookiero/messaging";
import { keepPreviousData, useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import { isScreenFilled } from "../../../../domain/screen/model/screenFilled";
import {
  viewStyleProfileDefinitionByCustomerId,
  ViewStyleProfileDefinitionByCustomerIdResult,
} from "../../../../projection/styleProfileDefinition/viewStyleProfileDefinitionByCustomerId";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewStyleProfileDefinitionByCustomerIdFunctionArgs {
  readonly customerId: string;
}

interface UseViewStyleProfileDefinitionByCustomerIdFunction {
  (
    args: UseViewStyleProfileDefinitionByCustomerIdFunctionArgs,
  ): UseQueryFunctionResult<ViewStyleProfileDefinitionByCustomerIdResult>;
}

const shouldInvalidate = (event: DomainEvent<MessageName>) => isScreenFilled(event);

const useViewStyleProfileDefinitionByCustomerId: UseViewStyleProfileDefinitionByCustomerIdFunction = ({ customerId }) =>
  useQuery<ViewStyleProfileDefinitionByCustomerIdResult>({
    query: viewStyleProfileDefinitionByCustomerId({ customerId }),
    contextId: MESSAGING_CONTEXT_ID,
    invalidation: shouldInvalidate,
    invalidationDelay: 600,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  });

export { useViewStyleProfileDefinitionByCustomerId };
